import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { AppRouter } from './AppRouter';
import { AdminDataProvider } from './contexts/AdminDataContext';
render(<AdminDataProvider data-id="element-1822">
    <AppRouter data-id="element-1823" />
  </AdminDataProvider>, document.getElementById('root'));